import HomeLink from "./HomeLink";
import TopBanner from "./TopBanner";
import CreditPanel from "./CreditPanel";

export default function MintTractors() {
    // const navigate = useNavigate();
    // const purchase = () => {
    //     console.log('purchasing...');
    //     navigate('/purchase');
    // }

    // let imgSize = 150;

    return (
        <div className="App-header" style={{display: 'flex', gap: '15px'}}>
            <div style={{width: '80%', minWidth: '750px'}}>
                <TopBanner />
            </div>
            <div className='mintTitle'>Tractors and Tanks</div>
            <div><img alt='' src='/4mint/tractors-500.gif'/></div>
            <div>Launching soon!</div>
            <CreditPanel/>
            <HomeLink/>
        </div>
    )
}